import React, { useState } from "react";
// import "./PuttingSplits.css";
import { graphql, useLazyLoadQuery } from "react-relay";
import PGAModelBuilderOutput from "../../PGAModelBuilderPage/PGAModelBuilderOutput";
import Button from "../../../../../Button";
import DraftkingsInfoOverlay from "../../../../../DraftKingsInfoOverlay";

const QUERY = graphql`
  query CourseHistoryQuery($eventId: ID!) {
    whoAmI {
      username
    }

    pgaTourGetCourseHistoryModelForEvent(eventId: $eventId) {
      id
    }
    pgaTourEvent(eventId: $eventId) {
      id
      tournament {
        officialName
      }
    }

    pgaEventCoursesForEvent(eventId: $eventId) {
      id
      course {
        name
      }
    }
  }
`;

export default function CourseHistory({ eventId }) {
  const [viewRanks, setViewRanks] = useState(false);
  const [selectedDkPlayerId, setSelectedDkPlayerId] = useState(undefined);

  const data = useLazyLoadQuery(QUERY, { eventId });

  const modelID = data.pgaTourGetCourseHistoryModelForEvent?.id;

  if (!modelID) {
    return (
      <div style={{ width: "100%", padding: "10px" }}>
        Course history is not ready yet for this event. Please check again
        later.
      </div>
    );
  }

  function showDKPlayerInfo(playerId) {
    if (playerId) {
      setSelectedDkPlayerId(playerId);
    }
  }

  function hideDKPlayerInfo() {
    setSelectedDkPlayerId(undefined);
  }

  const multipleCourses = data.pgaEventCoursesForEvent.length > 1;

  return (
    <div style={{ width: "100%", padding: "10px" }}>
      <DraftkingsInfoOverlay
        show={selectedDkPlayerId !== undefined}
        playerId={selectedDkPlayerId}
        close={hideDKPlayerInfo}
      />
      <div>
        <h3>
          Course{multipleCourses ? "s" : ""} for{" "}
          {data.pgaTourEvent.tournament.officialName}
        </h3>
        {data.pgaEventCoursesForEvent.map((eventCourse) => {
          let courseName = eventCourse.course?.name;

          if (!courseName) {
            courseName = "UNKNOWN";
          }

          return <p key={eventCourse.id}>{courseName}</p>;
        })}
        <p>
          Below output includes up to <strong>24 most recent rounds</strong>{" "}
          each player in field has played at{" "}
          {multipleCourses ? "these" : "this"} course
          {multipleCourses ? "s" : ""}.
        </p>
        <hr />
      </div>

      <Button href="/tools/pga-model">Model Builder</Button>
      <br />
      <PGAModelBuilderOutput
        modelID={modelID}
        viewRanks={viewRanks}
        showDKPlayerInfo={showDKPlayerInfo}
        setViewRanks={setViewRanks}
      />
    </div>
  );
}
